import React, { useEffect, useContext } from "react";
import Navbar from "../components/marketing/navbar/Navbar";
import Footer from "../components/marketing/footer/Footer";
import ModalCore from "../components/utils/modals/CoreModal";
import currentAdminContext from "../dataManager/context/currentAdminContext";
import { firebaseGetCurrentPerson } from "../api/admins/adminApi";
import { getAllCategories } from "../api/categories/categoriesApi.js";
import { getAllProducts } from "../api/products/productsApi";
import { useLocation } from "react-router-dom";
import Toast from "../components/utils/Toast";
import categoriesContext from "../dataManager/context/categoriesContext";
import productsContext from "../dataManager/context/productsContext";
import searchContext from "../dataManager/context/searchContext";
import usersContext from "../dataManager/context/usersContext";
import {
  getUserWithUpdatedData,
  getUserNoContactedByAdmin,
} from "../api/users/usersApi";

import { getAdminWithUpdatedData } from "../api/admins/adminApi";

const Base = ({ children }) => {
  // context variables
  const { login, currentAdmin } = useContext(currentAdminContext);
  const { getCategories } = useContext(categoriesContext);
  const { getProducts } = useContext(productsContext);
  const { resetAllSearch } = useContext(searchContext);
  const { getUsers } = useContext(usersContext);

  //location
  let { pathname } = useLocation();

  // some functions
  const fetchData = async () => {
    await firebaseGetCurrentPerson(login);
    await getAllCategories(getCategories);
    await getAllProducts(getProducts);
    await getUserNoContactedByAdmin(getUsers);

    if (currentAdmin) {
      if (currentAdmin.getRole === 0)
        return await getUserWithUpdatedData(currentAdmin.getId, login);

      //getAdminWithUpdateData
      await getAdminWithUpdatedData(currentAdmin.getId, login);
    }
  };

  useEffect(() => {
    //fetch and store categories and products in global state
    fetchData();
  }, []);

  // scroll to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  //if the current page is not the page all products, reset the search
  useEffect(() => {
    if (pathname !== "/produits") resetAllSearch();
  }, [pathname]);

  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer classe="separedSection" />

      <ModalCore />

      <Toast />
    </>
  );
};

export default React.memo(Base);
